import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import type { ShellData } from '@/lib/market/types'

import Head from 'next/head'
import { IBM_Plex_Mono, IBM_Plex_Sans, Sora } from 'next/font/google'
import SiteShell from '@/components/generals/site-shell'

const sans = IBM_Plex_Sans({
    subsets: ['latin']
})

const mono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500', '600']
})

const heading = Sora({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const shell = (pageProps as { shell?: ShellData | null }).shell ?? null

    return (
        <div className='flex min-h-screen flex-col font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <SiteShell shell={shell}>
                <Component {...pageProps} />
            </SiteShell>
        </div>
    )
}

export default App
